import React from 'react';
import { RowHeaderTable } from '../../components';
import TableReasonRefusal from '../../components/TableReasonRefusal';

const ReasonsRefusal: React.FC = () => {
  return (
    <div>
      <div className="container-body no-padding">
        <RowHeaderTable
          name="Motivos de recusa"
          navigationPath="/home/reason-refusal/create"
        />
        <TableReasonRefusal />
      </div>
    </div>
  );
};

export default ReasonsRefusal;
